module.exports = __webpack_public_path__ + "img/shib.a0e4d804.svg";